import tooltips from '../../config/tooltips';
import template from './sidebarBlockHeader.html';

export default function() {
  return {
    replace: true,
    scope: {
      name: '@',
      view: '@',
    },
    templateUrl: template,
    controller: Controller,
    controllerAs: 'sidebarBlockHeader',
    bindToController: true,
  };
}

function Controller() {
  this.tooltips = tooltips;
}



/** WEBPACK FOOTER **
 ** ../~/eslint-loader!./js/directives/sidebarBlockHeader/sidebarBlockHeader.js
 **/